import React, { useContext } from 'react';
import StateContext from 'common/contexts/state-context';
import { reassuranceItems } from '../staticContent';

/** `.rass` — barre de réassurance, identique en pied des deux pages. */
const ReassuranceBar = () => {
  const [state] = useContext(StateContext);

  return (
    <div className="rass" role="complementary" aria-label="Nos engagements">
      <div className="rass-inner">
        {reassuranceItems(state.brand?.placeCount).map((item) => (
          <div className="rass-item" key={item.title}>
            <div className="rass-ico">
              {/* Icône décorative : le texte qui suit porte déjà l'information. */}
              <img src={item.icon} alt="" width="56" height="56" loading="lazy" />
            </div>
            <div>
              <strong>{item.title}</strong>
              <small>{item.text}</small>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReassuranceBar;
